class HTTPService {
    formatRejectResponse(errorName = 'unknowError', response = {}) {
        const error = new Error(errorName);

        error.response = response;

        return error;
    }
}

export default new HTTPService();
